import * as React from 'react'
import styled from 'styled-components/macro'
import Modal from 'common/Modal'
import {submitQuoteRequest} from 'common/sendEmail'

import {
  Line,
  StyledLabel,
  StyledInput,
  StyledForm,
  Title,
  Button,
} from 'common/ModalFormComponents'

const Wrapper = styled.div`
  padding: 56px;
  color: var(--dark-grey);
  font-family: 'Mulish';
`

const ButtonBar = styled.div`
  display: flex;
  justify-content: flex-end;
`

const LauncherQuoteModal = ({showQuoteModal, setShowQuoteModal}) => {
  const [submitting, setSubmitting] = React.useState(false)
  const [submitSuccess, setSubmitSuccess] = React.useState(false)

  return (
    <Modal isOpen={showQuoteModal} onDismiss={() => setShowQuoteModal(false)}>
      <Wrapper>
        <StyledForm
          name="request-quote"
          method="POST"
          data-netlify={true}
          id="launcher-request"
        >
          <input
            type="hidden"
            name="subject"
            value="Launcher quote request from golfinvite.com"
            readOnly
          />
          <Title>Golf Ball Launcher Reservation Inquiry</Title>
          <Line>
            <StyledLabel name="Event Name" htmlFor="Event Name">
              Event Name
            </StyledLabel>
            <StyledInput width="504" name="Event Name"></StyledInput>
          </Line>
          <Line>
            <StyledLabel name="Event Date" htmlFor="Event Date">
              Event Date
            </StyledLabel>
            <StyledInput width="512" name="Event Date"></StyledInput>
          </Line>
          <Line>
            <StyledLabel name="Event Location" htmlFor="Event Location">
              Location of Event
            </StyledLabel>
            <StyledInput width="467" name="Event Location"></StyledInput>
          </Line>
          <Line>
            <StyledLabel
              name="Number of Participants"
              htmlFor="Number of Participants"
            >
              Number of Participants
            </StyledLabel>
            <StyledInput
              width="424"
              name="Number of Participants"
            ></StyledInput>
          </Line>
          <Line>
            <StyledLabel name="Contact Name" htmlFor="First Name">
              Contact Name
            </StyledLabel>
            <StyledInput width="228" name="First Name"></StyledInput>
            <StyledInput width="228" name="Last Name"></StyledInput>
          </Line>
          <Line>
            <StyledLabel name="email" htmlFor="email">
              Email
            </StyledLabel>
            <StyledInput width="553" name="email" id="email"></StyledInput>
          </Line>
          <Line>
            <StyledLabel name="Phone" htmlFor="Phone">
              Phone
            </StyledLabel>
            <StyledInput width="546" name="Phone"></StyledInput>
          </Line>
          <ButtonBar>
            {submitSuccess ? (
              <div>Request Sent!</div>
            ) : (
              <Button
                type="button"
                disabled={submitting}
                onClick={() =>
                  submitQuoteRequest({
                    setSubmitSuccess,
                    setSubmitting,
                    formID: 'launcher-request',
                  })
                }
                submitting={submitting}
              >
                {submitting ? 'Sending...' : 'Send'}
              </Button>
            )}
          </ButtonBar>
          <input
            type="hidden"
            name="form-name"
            value="request-quote"
            readOnly
          />
          <input type="hidden" name="Type" value="Launcher" readOnly />
        </StyledForm>
      </Wrapper>
    </Modal>
  )
}

export default LauncherQuoteModal
